<template>
  <ul class="fz-18 text-white font-medium pl-5 list-disc gap-7.5 flex flex-col">
    <li
        v-for="item in items"
        :key="item"
    >
      {{ item }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "markedList",
  props: ['items']
}
</script>

<style scoped>

</style>